import * as _ from 'lodash';

import { Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { FcpButtonSizes, FcpModalService } from 'fc-ui-components';
import { SegmentService } from 'services';
import { getIconLink } from 'helpers';
import { DownloadInitiator } from 'services/tracking/download-initiator';
import { DownloadsService } from 'app/content/services/downloads.service';
import { DownloadSelectionService } from 'app/content/components/download-selection-modal/download-selection.service';
import { DownloadSelection } from 'app/content/components/download-selection-modal/download-selection.types';
import {
    PRODUCT_VIDEO_PLACEHOLDER_CAMERA_SRC,
    downloadListItemUsesVideoPlaceholder
} from 'app/content/shared/product-video-placeholder.util';

@Component({
    selector: 'fc-download-cart',
    templateUrl: './download-cart.component.html',
    styleUrls: ['./download-cart.component.less'],
    standalone: false
})
export class DownloadCartComponent implements OnInit {
    @Input() isInMainContentDrawer = false;

    public readonly downloadSelectionModalId = 'downloadListSelectionModal';
    public readonly buttonSize = FcpButtonSizes;
    public products: any[] = [];
    public marketingImages: any[] = [];
    public videoOverlayIcon = getIconLink('mp4');
    public readonly videoPlaceholderCameraSrc = PRODUCT_VIDEO_PLACEHOLDER_CAMERA_SRC;
    public downloadListUpdatedSubscription: Subscription;

    private seasonsLookup = {
        spring_summer: 'SEASON_SPRING_SUMMER',
        fall_winter: 'SEASON_FALL_WINTER'
    };

    constructor(
        private downloadsService: DownloadsService,
        private segmentService: SegmentService,
        private downloadSelectionService: DownloadSelectionService,
        private fcpModalService: FcpModalService,
        private router: Router
    ) {}

    ngOnInit() {
        this.downloadListUpdatedSubscription = this.downloadsService.getDownloadListUpdated().subscribe(() => {
            this.products = this.downloadsService.getProducts();
            this.marketingImages = this.downloadsService.getMarketingFiles();
        });
    }

    public goToMyBrands() {
        this.router.navigate(['/r/brands']);
    }

    public openDownloadModal() {
        const { products, marketingImages } = this.downloadsService.getDownloadListTotalCountByVariant();
        const brandCount = this.downloadsService.getBrandCount();

        this.downloadSelectionService.setPendingContext({
            type: 'summaryBar',
            initiator: DownloadInitiator.SummaryBar
        });
        this.fcpModalService.open(this.downloadSelectionModalId);
        this.segmentService.track('[CO] Opened download dialog from Summary Bar', {
            marketingFileCount: marketingImages,
            productArticleCount: products,
            brandCount,
            contentContext: 'Download List'
        });
    }

    public onDownloadSelectionConfirmed(selection: DownloadSelection) {
        const { products, marketingImages } = this.downloadsService.getDownloadListTotalCountByVariant();
        const brandCount = this.downloadsService.getBrandCount();

        this.downloadSelectionService.executeDownload(selection);
        this.segmentService.track('[CO] Downloaded from Summary Bar', {
            marketingFileCount: marketingImages,
            productArticleCount: products,
            brandCount,
            imageDownloadType: selection.images,
            videoDownloadType: selection.video,
            csvDownloadType: selection.productAttributes,
            contentContext: 'Download List'
        });
    }

    public removeProduct(item) {
        this.downloadsService.removeProduct(item.productId);
        this.downloadsService.notifyDownloadListChanged();
    }

    public removeMarketingImage(item) {
        this.downloadsService.removeMarketingImage(item.productId);
        this.downloadsService.notifyDownloadListChanged();
    }

    public clearDownloads() {
        this.downloadsService.restore();
        this.downloadsService.notifyDownloadListChanged();
        this.segmentService.track('[CO] Clear Download list', {
            contentContext: 'Download List'
        });
    }

    public getSeasonName(item): string {
        const itemSeason = _.get(item, 'additionals.season', '');
        return this.seasonsLookup[itemSeason] || '';
    }

    public getSeasonYear(item): string {
        return _.get(item, 'additionals.year', '');
    }

    public trackByItemId(index, item) {
        return item._id;
    }

    public getIconLink(extension: string): string {
        return getIconLink(extension);
    }

    public showProductVideoPlaceholder(product: {
        type?: string;
        thumbnailSignedUrl?: string;
        hasPreview?: boolean;
        thumbnailFilename?: string;
    }): boolean {
        return downloadListItemUsesVideoPlaceholder(product);
    }

    get itemsCount(): number {
        return this.downloadsService.getCount();
    }
}
